
import React from "react";
import ColorCheckForm from "@/components/color-check/ColorCheckForm";
import EnhancedColorCheckResult from "@/components/color-check/EnhancedColorCheckResult";
import AILearningPanel from "@/components/color-check/AILearningPanel";
import { useEnhancedColorCheck } from "@/hooks/useEnhancedColorCheck";

const ColorCheck = () => {
  const {
    searchTerm,
    suggestions,
    showSuggestions,
    isLoading,
    isLearning,
    colorResult,
    recentChecks,
    handleSearchTermChange,
    handleSelectSuggestion,
    analyzeColor,
    provideFeedback,
    sendExternalRequest,
    formatTimestamp
  } = useEnhancedColorCheck();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">AI Kleurcontrole</h1>
        <p className="text-muted-foreground">
          Geavanceerde AI-gebaseerde kleuranalyse met self-learning technologie
        </p>
      </div>

      {/* AI Learning Status Panel */}
      <AILearningPanel 
        colorResult={colorResult}
        isLearning={isLearning}
        onProvideFeedback={provideFeedback}
      />

      <div className="grid gap-6 md:grid-cols-2">
        <ColorCheckForm
          searchTerm={searchTerm}
          suggestions={suggestions}
          showSuggestions={showSuggestions}
          isLoading={isLoading}
          recentChecks={recentChecks}
          formatTimestamp={formatTimestamp}
          onSearchChange={handleSearchTermChange}
          onSelectSuggestion={handleSelectSuggestion}
          onCheckColor={analyzeColor}
        />

        <EnhancedColorCheckResult
          colorResult={colorResult}
          onSendExternalRequest={sendExternalRequest}
          onProvideFeedback={provideFeedback}
        />
      </div>
    </div>
  );
};

export default ColorCheck;
